import { connect } from "react-redux";
import { enableTableScroll, disableTableScroll } from "../actions/loader";
import { MFModal } from "../components/MFModal";

export default connect(
  (state) => ({
    localConfigurator: state.configurator.localConfigurator,
  }),
  (dispatch) => ({
    enableTableScroll: () => {
      dispatch(enableTableScroll());
    },
    disableTableScroll: () => {
      dispatch(disableTableScroll());
    },
  }),
)(MFModal);
